import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Modal, List, Input, Row, Col, Button } from 'antd';
import { faSolidIcons, faBrandIcons } from '../../constants/faIcons';

const { Search } = Input;
const portionSize = 200;

export class IconChooserModal extends React.Component {
  constructor(props) {
    super(props);
    this.faAllIcons = faSolidIcons.concat(faBrandIcons);
    this.state = {
      searchQuery: null,
      searchFilterData: this.faAllIcons,
      ceiling: portionSize, // floor = 0
    };
    this.faAllIcons = faSolidIcons.concat(faBrandIcons);
  }

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    sender: PropTypes.shape({
      blockUrlsafe: PropTypes.string,
      address: PropTypes.array,
      selectedProp: PropTypes.string,
    }),
    onBlockUpdate: PropTypes.func.isRequired,
  };

  handleSearch = (value) => {
    if (value !== this.state.searchQuery) {
      this.setState({
        searchQuery: value,
        searchFilterData: value.length > 0 ? this.faAllIcons.filter(n => n.includes(value)) : this.faAllIcons,
        ceiling: portionSize,
      });
    }
  };

  handleSearchChange = (e) => {
    const { value } = e.target;
    if (value.length === 0) {
      this.setState({
        searchQuery: null,
        searchFilterData: faSolidIcons,
        ceiling: portionSize,
      });
    }
  };

  onModalCancel = () => {
    this.setState({
      searchQuery: null,
      // searchFilterData: [],
      ceiling: portionSize,
    });
    this.props.onClose();
  };

  iconItemSelected = (item) => {
    const { blockUrlsafe, address, selectedProp } = this.props.sender;
    this.props.onBlockUpdate(blockUrlsafe, address, { [selectedProp]: item });
    this.props.onClose();
  };

  onLoadMore = () => {
    this.setState({ ceiling: this.state.ceiling + portionSize });
  };

  renderItem = (item) => (
    <List.Item>
      <div className="icon__item py-3" onClick={() => this.iconItemSelected(item)}>
        <div>
          <i
            className={cx(
              {
                fas: faSolidIcons.includes(item),
                fab: faBrandIcons.includes(item),
              },
              `fa-${item}`,
            )}
          />
        </div>
        <div className="icon-caption text-secondary mt-3">{item}</div>
      </div>
    </List.Item>
  )

  render() {
    const { ceiling, searchFilterData } = this.state;

    const searchInputResp = {
      xs: 24,
      sm: { span: 18, offset: 3 },
      md: { span: 16, offset: 4 },
      lg: { span: 12, offset: 6 },
    };

    const isMore = (ceiling < searchFilterData.length);
    const pageFilterData = isMore ? searchFilterData.slice(0, ceiling) : searchFilterData;
    const loadMore = isMore ? (
      <div style={{ textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px' }}>
        <Button onClick={this.onLoadMore}>show more</Button>
      </div>
    ) : null;

    return (
      <Modal
        title={null}
        visible={this.props.visible}
        closable={true}
        maskClosable={true}
        onCancel={this.onModalCancel}
        footer={null}
        width={null}
        wrapClassName="editor__icon__modal__container"
        destroyOnClose={true}
      >
        <Row gutter={18} className="mb-5">
          <Col {...searchInputResp}>
            <Search
              onSearch={this.handleSearch}
              onChange={this.handleSearchChange}
              size="large"
              className="mt-3 mb-4"
              placeholder="search"
            />
          </Col>
        </Row>
        <List
          grid={{ gutter: 16, xs: 2, sm: 3, md: 6, lg: 6, xl: 8, xxl: 12 }}
          dataSource={pageFilterData}
          loadMore={loadMore}
          renderItem={this.renderItem}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/IconChooserModal.jsx